import { z } from 'zod';

export type RpeOption = z.output<typeof rpeOptionSchema>;
export type RpeOptionDTO = z.input<typeof rpeOptionSchema>;

export const rpeOptionSchema = z.object({
  value: z.number(),
  label: z.string().optional(),
  commentEnabled: z.boolean().optional(),
});
